import React from "react";
import ListPage from "./components/List/ListPage";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const ManagementCompanies = () => {
  return (
    <NavHeightAdjust>
      <ListPage />
    </NavHeightAdjust>
  );
};

export default ManagementCompanies;
